import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { LandingPageFacade } from '../store/facade/landing-page.facade';

@Component({
  selector: 'fm-reactivate-account-entry',
  standalone: true,
  template: '',
})
export class ReactivateAccountEntryComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly landingPageFacade = inject(LandingPageFacade);

  ngOnInit(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe((queryParams) => {
      const reactivateKey = queryParams.get('reactivateKey');
      this.landingPageFacade.resetReactivateAccountState();
      this.landingPageFacade.setReactivateKey(reactivateKey);
      if (!reactivateKey) {
        this.landingPageFacade.setReactivateAccountError(
          'Invalid reactivation link.',
        );
      }
      this.router.navigate(['/activating-account'], { replaceUrl: true });
    });
  }
}
